// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "rescript/lib/es6/belt_Option.js";

var isTestnet = Belt_Option.mapWithDefault(process.env.REACT_APP_NETWORK, false, (function (network) {
        return network === "TEST";
      }));

var availableNetworkIds = isTestnet ? [
    4,
    5,
    80001
  ] : [
    1,
    137
  ];

export {
  isTestnet ,
  availableNetworkIds ,
  
}
/* isTestnet Not a pure module */
